import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SOILSTRATUMTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SoilStratumType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SoilStratumType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const SOILSTRATUMTYPE_CONFIG = {
  entityName: 'SoilStratumType',
  localizationKey: 'Planning::Entity.SoilStratumType',
  fields: SOILSTRATUMTYPE_FIELDS,
  permission: 'PlanningEnvironment.SoilStratumTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
